import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook } from '@fortawesome/pro-solid-svg-icons'

const AccountSettings = (props) => {
  const height = props.ui?.window?.height - 150
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='f6 white' icon={faBook} />
          <div className='pl2 fw7 f6 white'>Account Settings </div>
          <div className='h2'></div>
        </div>
      </div>
      <div className='ph3 overflow-y-scroll' style={{height}}>
      </div>
    </div>
  )
}

export default AccountSettings